// src/store/store.js
import { configureStore } from "@reduxjs/toolkit";
import rootReducer from "./Reducers"; // Make sure this exports a combined reducer

const store = configureStore({
  reducer: rootReducer,
  // You can add middleware or devTools config here if needed
});

export default store;
